import { Pipe, PipeTransform } from '@angular/core';
import { InvoiceImportStatus } from 'src/app/models/invoice-import.model';
import { invoiceImportStatusBadgeClass } from 'src/app/services/invoice-import.util';

@Pipe({ name: 'invoiceImportStatusClass' })
export class InvoiceImportStatusClassPipe implements PipeTransform {
  transform(status: InvoiceImportStatus | string): string {
    return invoiceImportStatusBadgeClass(status as InvoiceImportStatus);
  }
}
